import deals from '@page/host-management/dashboards/marketing/assets/deals.svg'
import fansCartFilled, {
  ReactComponent as FansCartFilled,
} from '@page/host-management/dashboards/marketing/assets/fans-cart-filled.svg'
import fansCartIconSmall, {
  ReactComponent as FansCartIconSmall,
} from '@page/host-management/dashboards/marketing/assets/fans-cart-icon-small.svg'
import fansFollowersSmall, {
  ReactComponent as FansFollowersSmall,
} from '@page/host-management/dashboards/marketing/assets/fans-followers-icon-small.svg'
import fansHeartFilled, {
  ReactComponent as FansHeartFilled,
} from '@page/host-management/dashboards/marketing/assets/fans-heart-filled.svg'
import fansLargeHeartFilled, {
  ReactComponent as FansLargeHeartFilled,
} from '@page/host-management/dashboards/marketing/assets/fans-large-heart.svg'
import fansLeadsSmall, {
  ReactComponent as FansLeadsSmall,
} from '@page/host-management/dashboards/marketing/assets/fans-leads-icon-small.svg'
import fansMessaging, {
  ReactComponent as FansMessaging,
} from '@page/host-management/dashboards/marketing/assets/fans-messaging.svg'
import fansOneTimersSmall, {
  ReactComponent as FansOneTimersSmall,
} from '@page/host-management/dashboards/marketing/assets/fans-one-time-icon-small.svg'
import fansOneTimersFilled, {
  ReactComponent as FansOneTimersFilled,
} from '@page/host-management/dashboards/marketing/assets/fans-one-timers-filled.svg'
import fansRepeatGuestsFilled, {
  ReactComponent as FansRepeatGuestsFilled,
} from '@page/host-management/dashboards/marketing/assets/fans-repeat-guests-filled.svg'
import fansRepeatSmall, {
  ReactComponent as FansRepeatSmall,
} from '@page/host-management/dashboards/marketing/assets/fans-repeat-icon-small.svg'
import featuredPromoCodes, {
  ReactComponent as FeaturedPromoCodes,
} from '@page/host-management/dashboards/marketing/assets/featured-promo-codes.svg'
import giftBox, {
  ReactComponent as GiftBox,
} from '@page/host-management/dashboards/marketing/assets/gift-box.svg'
import hostPromoCodes, {
  ReactComponent as HostPromoCodes,
} from '@page/host-management/dashboards/marketing/assets/host-promo-codes.svg'
import listingCard from '@page/host-management/dashboards/marketing/assets/listing-card.png'
import loudSpeakerSmall, {
  ReactComponent as LoudSpeakerSmall,
} from '@page/host-management/dashboards/marketing/assets/loud-speaker.svg'
import promoTagSuccess, {
  ReactComponent as PromoTagSuccess,
} from '@page/host-management/dashboards/marketing/assets/promo-tag-success.svg'

export const marketingAssets = {
  giftBox,
  GiftBox,

  hostPromoCodes,
  HostPromoCodes,

  fansCartIconSmall,
  FansCartIconSmall,
  fansCartFilled,
  FansCartFilled,
  fansHeartFilled,
  FansHeartFilled,
  fansLargeHeartFilled,
  FansLargeHeartFilled,
  fansOneTimersFilled,
  FansOneTimersFilled,
  fansMessaging,
  FansMessaging,
  fansRepeatGuestsFilled,
  FansRepeatGuestsFilled,
  fansFollowersSmall,
  FansFollowersSmall,
  fansLeadsSmall,
  FansLeadsSmall,
  loudSpeakerSmall,
  LoudSpeakerSmall,
  fansOneTimersSmall,
  FansOneTimersSmall,
  fansRepeatSmall,
  FansRepeatSmall,

  featuredPromoCodes,
  FeaturedPromoCodes,
  promoTagSuccess,
  PromoTagSuccess,

  deals,
  listingCard,
}
